var EmailCreationQueueService = (function () {
    function EmailCreationQueueService($http) {
        this.$http = $http;
        this.WsUrl = ResolveUrl("~/LoanData.asmx");
    }
    EmailCreationQueueService.prototype.getAll = function (CompanyID) {
        return this.$http.post(this.WsUrl + "/GetAllEmailCreationQueue", {
            CompanyID: CompanyID
        });
    };
    EmailCreationQueueService.$inject = ["$http"];
    return EmailCreationQueueService;
}());
angular
    .module("London.Services")
    .service("EmailCreationQueueService", EmailCreationQueueService);
